'use client';

import { Render } from '@measured/puck';
import config from '@admin/config';

export function Client({
  data,
  type,
}: {
  data: any;
  type?: 'unpublished' | 'published';
}) {
  const root = {
    title: data.title,
    slug: data.slug,
    settings: data.settings,
    type,
  };
  const renderConfig = config(root, true);

  return <Render config={renderConfig} data={data} />;
}
